import EFPicture from '@elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EfSpec from '@elem/ui/ef-spec';

let titleSceneC: any = null;
export default function CutCosts() {
    const { useLang, useRouter, useEffect, useState, gtm } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('delta_pro_ultra.launch.detail.CutCosts');
    const [textEnter, setTextEnter] = useState(false);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resizeAni = () => {
                if (titleSceneC) {
                    AniContainer.removeScene(titleSceneC);
                    titleSceneC = null;
                }

                const clientH = (window.innerHeight || 0) * 0.2;
                const startH = Math.min(clientH, 150);
                titleSceneC = AniContainer.create({
                    triggerElement: '.CutCosts-detail .sticky-box',
                    triggerHook: 1,
                    offset: '50%',
                    duration: 200,
                    onEnter: () => {
                        setTextEnter(true);
                    },
                });
            };
            resizeAni();
            return () => {
                if (titleSceneC) {
                    AniContainer.removeScene(titleSceneC);
                    titleSceneC = null;
                }
            };
        }
    }, []);

    return (
        <>
            <section className={`CutCosts-detail CutCosts-detail-section ${css['CutCosts-detail']}`} id="CutCosts">
                <div className={`sticky-box ${textEnter ? 'enter' : ''}`}>
                    <div className="img-box">
                        <EFPicture
                            src={'https://websiteoss.ecoflow.com/upload/image/1747999051237/Pillar_3_1920%20(1).jpg'}
                            srcPad={'https://websiteoss.ecoflow.com/upload/image/1747999050894/Frame%201612707585.jpg'}
                            alt={t('title')}
                        />
                        <div className="mask"></div>
                        <div className="title-box">
                            <h2 className="title">{t('title')}</h2>
                            <p className="desc">{t('desc')}</p>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}
